import React from 'react';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <footer id="footer" className="bg-primary dark:bg-gray-900 text-white pt-16 pb-8">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">
              <span className="text-secondary dark:text-white"><img className="nav-logo" src={require('../assets/logo-big.png')}  alt="Aiabc 英语自主学习系统" /></span>
            </h3>
            <p className="text-gray-300 text-sm mb-6">做英语提分一站式解决方案的引领者</p>
            <div className="flex space-x-4">
              <a href="#footer" className="w-10 h-10 rounded-full bg-white/10 hover:bg-secondary transition-colors duration-300 flex items-center justify-center">
                <i className="fab fa-weixin"></i>
              </a>
              <a href="#footer" className="w-10 h-10 rounded-full bg-white/10 hover:bg-secondary transition-colors duration-300 flex items-center justify-center">
                <i className="fab fa-qq"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">公司</h4>
            <ul className="space-y-2">
              <li><a href="#about" className="text-gray-300 hover:text-secondary transition-colors">关于我们</a></li>
              <li><a href="#features" className="text-gray-300 hover:text-secondary transition-colors">提分系统</a></li>
              <li><a href="#faq" className="text-gray-300 hover:text-secondary transition-colors">常见问题</a></li>
              <li><a href="#footer" className="text-gray-300 hover:text-secondary transition-colors">联系我们</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">提分</h4>
            <ul className="space-y-2">
              <li><a href="#features" className="text-gray-300 hover:text-secondary transition-colors">关于系统</a></li>
              <li><a href="#features" className="text-gray-300 hover:text-secondary transition-colors">产品定位</a></li>
              <li><a href="#features" className="text-gray-300 hover:text-secondary transition-colors">解决方案</a></li>
              <li><a href="#features" className="text-gray-300 hover:text-secondary transition-colors">产品亮点</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">联系我们</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <i className="fas fa-map-marker-alt mt-1 mr-3 text-secondary"></i>
                <span className="text-gray-300">深圳市宝安区西乡街道</span>
              </li>
              <li className="flex items-start">
                <i className="fas fa-phone-alt mt-1 mr-3 text-secondary"></i>
                <span className="text-gray-300">商务洽谈:131-1304-5345(韩总)</span>
              </li>
              <li className="flex items-start">
                <i className="fas fa-envelope mt-1 mr-3 text-secondary"></i>
                <span className="text-gray-300">service@aiabc.me</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">© 2025 深圳知行合一慧科技. 保留所有权利</p>
            <div className="flex space-x-6">
              <a href="https://beian.miit.gov.cn/" target="_blank" className="text-gray-400 hover:text-secondary text-sm transition-colors">粤ICP备2023074446号</a>
            </div>
          </div>
        </div>
      </div>

      <motion.div
        className="w-full h-1 bg-gradient-to-r from-primary via-secondary to-primary mt-8"
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.5 }}
      />
    </footer>
  );
};

export default Footer;
